export default "__VITE_ASSET__c579c989__"